module.exports = __webpack_public_path__ + "roboto-bold-webfont-5bacc29257521cc73732f2597cc19c4b.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-bold-webfont.ttf
// module id = 834
// module chunks = 76